import { Directive, ElementRef, Renderer2, OnInit, AfterViewInit } from "@angular/core";

@Directive({
  selector: "[bfxautofocus]",
  standalone: false,
})
export class BfxAutoFocus implements AfterViewInit {
  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
  ) {}

  ngOnInit() {}

  ngAfterViewInit() {
    // this.renderer.invokeElementMethod(this.el.nativeElement, 'focus', []);//ANGULAR UPGRADE CHANGE
    this.el.nativeElement.focus();
  }
}
